


































import BaseComponent from '@/components/base-component.vue';
import PrescriptionAlertsDetails from '@/components/prescription/alerts/alerts-details.vue';
import PrescriptionAlertsMessages from '@/components/prescription/alerts/alerts-messages.vue';
import CollapsibleCard from '@/components/UI/collapsible-card.vue';
import {
  PrescriptionValidation,
  VALIDATION_ALERT_IMPEDITIVE,
  VALIDATION_ALERT_WARNING
} from '@/settings/consts/prescription-validation';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PrescriptionAlertsCounterHeader from './alerts/alerts-counter-header.vue';
@Component({
  components: {
    CollapsibleCard,
    PrescriptionAlertsDetails,
    PrescriptionAlertsMessages,
    PrescriptionAlertsCounterHeader
  },
})
export default class PrescriptionValidationMessages extends BaseComponent {
  
  @Prop()
  public data!: any;
  @Prop()
  public prescriptionState: any;
  @Prop(Boolean)
  public loading?: boolean;
  @Prop(Boolean)
  public error?: boolean;
  @Prop(Boolean)
  public firstValidation?: boolean;

  public modalOpen?: boolean = false;
  public alertsTypes: any = {
    impeditive: VALIDATION_ALERT_IMPEDITIVE,
    warning: VALIDATION_ALERT_WARNING,
  };

  @Watch('data')
  public onChangeData(val: any): void {
    this.onCloseModal();
  }

  public onClickShowErrorProducts(val): void {
    this.$emit('clickShowErrorProducts', val);
  }

  public onClickFocusErrorProduct(val): void {
    this.$emit('clickFocusErrorProduct', val);
  }

  public onOpenModal(): void {
    this.modalOpen = !this.modalOpen;
    this.$emit('open');
  }

  public onCloseModal(): void {
    this.modalOpen = false;
    this.$emit('close');
  }

  getFirstValidationMessage() {
    if (!this.isInvalid()) {
      return null;
    }
    return "Existem campos na prescrição pendentes de preenchimento.";
  }

  public isInvalid(): boolean {
    return this.prescriptionState === PrescriptionValidation.INVALID.key;
  }
}
